import { string, object, number, array, date, bool } from 'yup';
import { isDate } from 'date-fns';
import dayjs from 'dayjs';

const parseDateString = (originalValue) => {
    const parsedDate = isDate(originalValue) ? originalValue : new Date(dayjs(originalValue))
    return parsedDate;
}

export const validationProjectSchema = object().shape({
    title: string().required('Project Title is required'),
    name: string().required('Project Name is required'),
    description: string().required('Description is required'),
    projectCategoryId: string().required('Project type is required'),
    endDate: date()
        .typeError("End date is required")
        .transform(parseDateString)
        .required("End date is required")
});

export const validationRoleSchema = object().shape({
    profileCategoryId: string().required("Profile category is required"),
    gender: string().required('Gender is required'),
    language: array().min(1, 'Languages is required').required('Languages is required'),
    roleTypeId: string().required('Role is required'),
    ageRange: array().required('Age range is required'),
    characterDescription: string().required('Character description is required'),
    shootLocation: string(),
    auditionLocation: string(),
    numberOfDays: number().transform(value => (isNaN(value) ? undefined : value))
        .integer("Must be integer only").min(1, "Must be greater than 0"),
    negotiable: bool(),
    minBudget: number().transform(value => (isNaN(value) ? undefined : value))
        .when('negotiable', (value, schema) => {
            if (Boolean(value[0])) return schema
            else return schema
                .test('Compare', 'Invalid budget range', (value, testContext) => (!testContext.parent.maxBudget && !value) || testContext.parent.maxBudget >= value)
        }),
    maxBudget: number().transform(value => (isNaN(value) ? undefined : value))
        .notRequired()
        .nullable()
        .when('negotiable', (value, schema) => {
            if (Boolean(value[0])) return schema
            else return schema
                .test('Compare', 'Invalid budget range', (value, testContext) => (!testContext.parent.minBudget && !value) || testContext.parent.minBudget <= value)
        }),
    payBasis: string(),
});
